import {
    useMemo,
} from 'react'
import CollapsibleTable from 'app/shared-components/CollapsibleTable'
import Card from 'app/shared-components/Card'
import {
    AccountLane,
} from 'app/Apps/AccountManagement/AccountLanes/AccountLanes.types'
import useLabel from 'app/hooks/useLabel'
import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import AssignPricingLaneUpdate from './AssignPricingLaneUpdate'

import getColumns from './AssignPricingLanes.columns'
import useStyles from './AssignPricingLanes.styles'

const AssignPricingLanes = ({
    lanes,
    onSuccess,
}: {
    lanes: AccountLane[],
    onSuccess: () => void,
}) => {
    const {
        classes,
    } = useStyles()
    const getLabel = useLabel()
    const {
        Lanes: LanesRoutes,
        Opportunities: OpportunitiesRoutes,
    } = useAccountManagementRoutes()

    const requestHandlers = useMemo(() => {
        return {
            data: lanes,
            loadData: () => {
                return Promise.resolve({
                    data: lanes,
                })
            },
            refetch: onSuccess,
        }
    }, [
        lanes,
        onSuccess,
    ])

    const columns = useMemo(() => {
        return getColumns({
            laneLinkConfig: {
                path: LanesRoutes.Overview.path,
                params: {
                    key: 'id',
                },
            },
            opportunityLinkConfig: {
                path: OpportunitiesRoutes.Overview.path,
                params: {
                    key: 'opportunityId',
                },
            },
            getLabel,
        })
    }, [
        LanesRoutes.Overview.path,
        OpportunitiesRoutes.Overview.path,
        getLabel,
    ])

    return (
        <Card contentClass={classes.container}>
            <CollapsibleTable
                title="Lanes"
                domainName="Lane"
                createEnabled={false}
                requestHandlers={requestHandlers}
                actionComponents={{
                    Update: AssignPricingLaneUpdate,
                }}
                columns={columns}
                hideAllControls
                ignorePreloading
                ignoreNavigation
            />
        </Card>

    )
}

export default AssignPricingLanes
